<template>
    <div id="approved-text">
        <perfect-scrollbar class="scroll-area">
            <b-overlay :show="isLoading">
                <p v-if="templates.length === 0 && !isLoading">{{ $t("entities.templates.no-templates-found") }}</p>

                <b-list-group v-else>
                    <b-list-group-item
                        v-for="template in templates"
                        :key="template.id"
                        button
                        class="flex-column align-items-start pb-1 pt-1 border-0"
                        @click="
                            $emit('set-template', {
                                id: template.id,
                                content: template.content,
                                title: template.title,
                                components: template.components,
                            })
                        "
                    >
                        <div class="d-flex w-100 justify-content-between align-items-start round">
                            <h5>&#47;{{ template.title }}</h5>
                            <b-button
                                v-if="fetchVariablesFromContent(template.content)"
                                class="btn-icon ml-50"
                                size="sm"
                                variant="light"
                                @click="$emit('manage-template', template)"
                            >
                                <font-awesome-icon icon="pen" />
                            </b-button>
                        </div>
                        <b-card-text class="text-secondary">
                            <span class="template-content">{{ template.content }}</span>
                        </b-card-text>
                    </b-list-group-item>
                </b-list-group>
            </b-overlay>
        </perfect-scrollbar>
    </div>
</template>

<script>
import useActiveChatTemplates from "@/composables/useActiveChatTemplates";
import { BListGroup, BListGroupItem, BCardText, BOverlay, BButton } from "bootstrap-vue";
import useTemplates from "@/composables/useTemplates";

export default {
    components: {
        BListGroup,
        BListGroupItem,
        BCardText,
        BOverlay,
        BButton,
    },
    props: {
        activeChat: {
            type: Object,
            required: true,
        },
    },
    setup(props) {
        const { fetchVariablesFromContent, isManageTemplatePanelActive } = useActiveChatTemplates();
        const { templates, fetchTemplates, isLoading } = useTemplates();

        isManageTemplatePanelActive.value = false;
        fetchTemplates({
            params: {
                join: "channels||id",
                fields: "title,content,components",
                s: {
                    mediaType: {
                        $isnull: true,
                    },
                    "channels.id": {
                        $eq: props.activeChat.channel.id,
                    },
                },
            },
        });

        return {
            isLoading,
            templates,

            // Methods
            fetchVariablesFromContent,
        };
    },
};
</script>
